import { movies } from "@/mocks/catalog";
import MovieCard from "@/components/feature/MovieCard";
import SectionHeading from "@/components/feature/SectionHeading";

const subThemes = [
  {
    icon: "ri-rocket-2-line",
    title: "深空探索",
    text: "以远距离航行、空间站与未知星体为舞台，强调孤独感与探索的代价。",
  },
  {
    icon: "ri-robot-2-line",
    title: "人工智能",
    text: "围绕自我意识与伦理边界展开，讨论技术被赋予判断力之后会发生什么。",
  },
  {
    icon: "ri-timer-flash-line",
    title: "时间与循环",
    text: "用循环、回溯与平行结构制造悬念，考验观众对线索的观察与拼接。",
  },
];

export default function ScifiSection() {
  const items = movies.filter((m) => m.genre === "科幻片");

  return (
    <section id="scifi" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="科幻片专区"
          title="科幻片：在宏大设定里讨论人的选择"
          description="科幻片先用一个「如果……」的假设搭建世界，再让角色在规则之下做出取舍。看点往往不在特效本身，而在设定带来的道德与情感难题。下面按三个常见子方向梳理。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {subThemes.map((theme, index) => (
            <div
              key={theme.title}
              className="relative flex flex-col gap-3 rounded-lg border border-background-200 bg-background-100/60 p-5"
            >
              <span className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${theme.icon} text-lg`}></i>
                </span>
                <span className="font-heading text-sm font-semibold text-foreground-500">
                  方向 0{index + 1}
                </span>
              </span>
              <h3 className="font-heading text-lg font-semibold text-foreground-950">
                {theme.title}
              </h3>
              <p className="text-sm leading-relaxed text-foreground-600">{theme.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}